import { Table, TableBody, TableCell, TableHead, TableRow, useTheme } from '@mui/material';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { StackedTextCell } from '@retail/components';
import { PurchaseAgreement } from '@retail/purchase-agreements/types';
import { Supplier } from '@retail/suppliers/types';

export interface SupplierWithActiveAgreement {
  supplier: Supplier;
  activeAgreement?: PurchaseAgreement;
}

interface Props {
  suppliersWithActiveAgreement: SupplierWithActiveAgreement[];
  renderAgreements: (supplier: SupplierWithActiveAgreement) => React.ReactNode;
}

export function ActivateSupplierLevelAgreementTable({
  suppliersWithActiveAgreement,
  renderAgreements,
}: Props) {
  const t = useCalculusTFunction();
  const theme = useTheme();
  const palette = theme.vars.palette;

  return (
    <Table size="small">
      <TableHead>
        <TableRow sx={{ borderBottom: (theme) => `1.5px solid ${theme.vars.palette.grey[100]}` }}>
          <TableCell
            width={200}
            sx={{ fontWeight: 600, fontSize: 16, borderRight: `1px solid ${palette.grey[100]}` }}
          >
            {t('calculus.level.supplier')}
          </TableCell>
          <TableCell width={200} sx={{ fontWeight: 600, fontSize: 16 }}>
            {t('calculus.purchaseAgreements')}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {suppliersWithActiveAgreement.map((supplierWithActiveAgreement, index) => (
          <TableRow
            key={supplierWithActiveAgreement.supplier.mgSupplierId}
            sx={{
              backgroundColor: (theme) =>
                index % 2 === 0 ? theme.vars.palette.grey[50] : undefined,
            }}
          >
            <TableCell
              sx={{
                borderRight: `1px solid ${palette.grey[100]}`,
                borderTop: `1px solid ${palette.grey[100]}`,
                borderBottom: `1px solid ${palette.grey[100]}`,
              }}
            >
              <StackedTextCell
                topLine={supplierWithActiveAgreement.supplier.name}
                bottomLine={supplierWithActiveAgreement.supplier.mgSupplierId}
              />
            </TableCell>
            {renderAgreements(supplierWithActiveAgreement)}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
